import React from 'react';
import Reveal from './Reveal';
import Container from './Container';

export interface SectionProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
    id?: string;
    /** Optional heading, rendered as an `<h2 class="section-title">` that scroll-reveals. */
    title?: React.ReactNode;
    titleClassName?: string;
    /** Wrap `children` in a `Container` to cap the content width. Defaults to `false`. */
    contained?: boolean;
    children: React.ReactNode;
}

/**
 * Standard page-section shell: a `<section>` with an optional animated
 * title, used consistently across the homepage instead of every component
 * re-implementing its own `<section>` + `<h2 class="section-title">` markup.
 */
const Section: React.FC<SectionProps> = ({
    id,
    className = '',
    title,
    titleClassName = '',
    contained = false,
    children,
    ...rest
}) => {
    const content = contained ? <Container>{children}</Container> : children;

    return (
        <section id={id} className={className} {...rest}>
            {title && (
                <Reveal as="h2" className={['section-title', titleClassName].filter(Boolean).join(' ')}>
                    {title}
                </Reveal>
            )}
            {content}
        </section>
    );
};

export default Section;
